/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  AuthVisitorAuthenticationCodeRequestResponseVisitor,
  AuthVisitorAuthenticationCodeRequestResponseVisitorFromJSON,
  AuthVisitorAuthenticationCodeRequestResponseVisitorFromJSONTyped,
  AuthVisitorAuthenticationCodeRequestResponseVisitorToJSON
} from './AuthVisitorAuthenticationCodeRequestResponseVisitor'

/**
 *
 * @export
 * @interface AuthVisitorAuthenticationCodeRequestResponse
 */
export interface AuthVisitorAuthenticationCodeRequestResponse {
  /**
   *
   * @type {AuthVisitorAuthenticationCodeRequestResponseVisitor}
   * @memberof AuthVisitorAuthenticationCodeRequestResponse
   */
  visitor?: AuthVisitorAuthenticationCodeRequestResponseVisitor
}

export function AuthVisitorAuthenticationCodeRequestResponseFromJSON(
  json: any
): AuthVisitorAuthenticationCodeRequestResponse {
  return AuthVisitorAuthenticationCodeRequestResponseFromJSONTyped(json, false)
}

export function AuthVisitorAuthenticationCodeRequestResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthVisitorAuthenticationCodeRequestResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    visitor: !exists(json, 'visitor')
      ? undefined
      : AuthVisitorAuthenticationCodeRequestResponseVisitorFromJSON(json['visitor'])
  }
}

export function AuthVisitorAuthenticationCodeRequestResponseToJSON(
  value?: AuthVisitorAuthenticationCodeRequestResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    visitor: AuthVisitorAuthenticationCodeRequestResponseVisitorToJSON(value.visitor)
  }
}
